// extracted by mini-css-extract-plugin
export var centerText = "_di-8";
export var container = "_di-0";
export var doughnutContainer = "_di-7";
export var legend = "_di-a";
export var legendItemColorDisplay = "_di-b";
export var legendItemLabel = "_di-d";
export var legendItemValue = "_di-c";
export var lg = "_di-5";
export var maxWidth = "_di-9";
export var md = "_di-4";
export var responsive = "_di-6";
export var sm = "_di-3";
export var xs = "_di-2";
export var xxs = "_di-1";